export default __webpack_public_path__ + "static/media/geo-5.b7663082.png";